<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Definizioni', route: '/backoffice/abbecedario/' }, { label: 'Modifica Definizione', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI DEFINIZIONE</h1>
</section>


<section class="pb-16 mb-8 px-container">

    <form [formGroup]="formDefinizione" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Alfabeto</label>
                <p-dropdown [options]="alfabeto" optionLabel="lettera" placeholder="Seleziona una lettera dell'alfabeto" formControlName="alfabeto"></p-dropdown>
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('alfabeto')?.hasError('required') && (formDefinizione.get('alfabeto')?.dirty || formDefinizione.get('alfabeto')?.touched)">La lettera dell'alfabeto è obbligatoria!.</small>
            </div>
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('titolo')?.hasError('required') && (formDefinizione.get('titolo')?.dirty || formDefinizione.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>                                                                     
            <div class="w-full">
                <label>* Definizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="definizione" (ngModelChange)="onDefinizione($event)" />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('definizione')?.hasError('required') && (formDefinizione.get('definizione')?.dirty || formDefinizione.get('definizione')?.touched)">La descrizione è obbligatorio!.</small>
            </div>                
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formDefinizione.valid">Modifica la definizione</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmPopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeletePopup($event)">Elimina la definizione</button>
                </div>
            </div>    
        </div>
    </form>

</section>